<script>
	import { getContext } from "svelte";
	import chroma from "chroma-js";
	import { px, percent } from "../utils";
	const { padding, xRange, xScale, yScale, yDomain } = getContext("LayerCake");

	export let start;
	export let end;
	export let label = "";
	export let color = "#f2f2f2";

	const left = $xScale(start);
	const width = $xScale(end) - $xScale(start);

	const top = $yScale(0);
	const height = $yScale($yDomain[0]) - top;
</script>

<div
	class="highlight"
	style:left={percent(left)}
	style:width={percent(width)}
	style:top={percent(top)}
	style:height={percent(height)}
>
	<div class="tick start" />
	<div class="line" />
	<div class="tick end" />
	<div class="label">
		{label}
	</div>
</div>

<style lang="scss">
	.highlight {
		mix-blend-mode: multiply;
		position: absolute;
		pointer-events: none;
	}

	.label {
		font-weight: 600;
		font-size: 11.5px;
		line-height: 11px;
		letter-spacing: 0.04em;
		position: absolute;
		top: 10px;
		left: 50%;
		transform: translateX(-50%);
	}

	.tick {
		height: 10px;
		width: 2px;
		background-color: #2a2a2a;
		position: absolute;

		&.start {
			left: 0;
			transform: translateX(-25%);
		}

		&.end {
			right: 0;
			transform: translateX(50%);
		}
	}

	.line {
		width: 100%;
		height: 2px;
		background-color: #2a2a2a;
		position: absolute;
	}
</style>
